import http from "../utils/http";

import config from "../config";
import { FormikValues } from "formik";

/**
 * Get all
 **/
const getAll = async () => {
  const url = `${config.baseUrl}${config.endPoints.disease.getAll}`;
  return http.get(url);
};

const getById = async (id: string) => {
  const url = `${config.baseUrl}${config.endPoints.disease.getById(id)}`;
  return http.get(url);
};

const create = async ( payload: FormikValues) => {
  const url = `${config.baseUrl}${config.endPoints.disease.add}`;
  return http.post(url, payload);
};

const update = async (id: string, body: any) => {
  const url = `${config.baseUrl}${config.endPoints.disease.update(id)}`;
  return http.put(url, body);
};

const deleteDisease = async (id: string) => {
  const url = `${config.baseUrl}${config.endPoints.disease.delete(id)}`;
  return http.delete(url);
};

const diseaseService = {
  getAll,
  getById,
  create,
  update,
  deleteDisease
};

export default diseaseService;
